import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const INVOICE_SETTINGS_ENDPOINT = 'invoices/v1/settings';
const INVOICE_SETTINGS_CUSTOM_FIELDS_ENDPOINT = 'invoices/v1/settings/custom-field';
export const getInvoiceSettings = () => {
  return http.get(INVOICE_SETTINGS_ENDPOINT).then(response => ({
    initialPrefix: response.INVOICE_NUMBER_PREFIX.value,
    startingNumber: response.INVOICE_NUMBERING_START.value,
    generateSubscriptionInvoices: response.GENERATE_INVOICES_FOR_SUBSCRIPTIONS.value,
    invoicesTaxId: response.INVOICE_TAX_ID.value,
    canEditOpenInvoice: response.INVOICE_EDIT.value,
    overrideCustomFields: response.INVOICE_OVERRIDE_CUSTOM_FIELDS.value,
    defaultEmail: response.DEFAULT_FROM_EMAIL_ADDRESS.value,
    allowOtherEmail: response.ALLOW_OTHER_EMAIL_ADDRESS.value
  })).catch(error => {
    throw error;
  });
};
export const getInvoiceCustomFieldsSettings = () => {
  return http.get(INVOICE_SETTINGS_CUSTOM_FIELDS_ENDPOINT).then(response => response.customFields).catch(error => {
    throw error;
  });
};
export const setDefaultCustomFieldSettings = customFields => http.post(INVOICE_SETTINGS_CUSTOM_FIELDS_ENDPOINT, {
  data: {
    portalId: PortalIdParser.get(),
    customFields
  }
});